<script>
export default {
  name: "DidoApidocExamples",
};
</script>

<script setup>
import DidoCodeHightlighting from "./codeHighlighting/Base.vue";
import DidoApidocExamplesTools from "./examples/Tools.vue";
import DidoApidocExamplesProcess from "./examples/Process.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
});

const exportBaseApiUrlCode = `export BASE_URL_API=${props.apiUrl}`;
</script>

<template>
  <div class="q-ml-md">
    <QExpansionItem
      id="base_url"
      label="4.1 - Gestion de l'url de base de l'API"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <div class="q-mt-md line-height-15">
        Tous les exemples utilisent le point d'entrée suivant pour l'api DiDo:
        <span class="text-underline">{{ props.apiUrl }}</span> <br /><br />
        Afin de ne pas avoir à saisir cette valeur pour chacun des exemples,
        vous pouvez affecter cette valeur à la variable d'environnement
        BASE_URL_API :
        <!-- Highlighting code -->
        <DidoCodeHightlighting language="shell" :code="exportBaseApiUrlCode" />
      </div>
    </QExpansionItem>
    <!-- Tools -->
    <QExpansionItem
      id="tools"
      label="4.2 - Vérification des outils"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocExamplesTools />
    </QExpansionItem>
    <!-- Process various examples -->
    <!-- Tools -->
    <QExpansionItem
      id="process"
      label="4.3 - Divers exemples"
      header-class="text-h6 bg-grey-1"
      dense
      class="q-mt-sm"
    >
      <DidoApidocExamplesProcess />
    </QExpansionItem>
  </div>
</template>
